import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWhatsappmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.002 0h-.004C4.035 0 0 4.037 0 9c0 1.969.634 3.793 1.713 5.275L.592 17.62l3.46-1.106A8.922 8.922 0 0 0 9.001 18C13.965 18 18 13.962 18 9s-4.035-9-8.998-9Z",
		fill: "#4CAF50"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.24 12.71c-.217.612-1.08 1.12-1.767 1.27-.47.1-1.084.18-3.152-.678-2.645-1.096-4.348-3.783-4.48-3.958-.128-.174-1.07-1.423-1.07-2.714 0-1.292.656-1.92.92-2.19.218-.222.577-.324.921-.324.111 0 .211.006.301.01.265.012.398.027.572.445.217.523.746 1.814.809 1.947.064.133.128.313.038.487-.084.18-.159.26-.291.413-.133.153-.259.27-.392.434-.121.143-.259.296-.106.56.153.26.682 1.122 1.46 1.815 1.005.895 1.82 1.18 2.111 1.302.217.09.476.069.635-.1.201-.217.45-.577.703-.932.18-.254.407-.285.646-.195.243.084 1.528.72 1.793.851.264.133.439.196.503.307.063.112.063.635-.154 1.25Z",
		fill: "#FAFAFA"
	})]
});
const ForwardRef = forwardRef(SvgWhatsappmin);
export { ForwardRef as ReactComponent };
